import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=9cb84b98&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioPlayer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=9cb84b98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb84b98",
  null
  
)

export default component.exports